// Keep invoice identities distinct: equal invoice numbers do not identify the same invoice.
function summarizePayments(candidates) {
  const groups = new Map();
  for (const candidate of candidates) {
    const key = JSON.stringify([candidate.providerId, candidate.accountId, candidate.transactionId, candidate.currencyCode]);
    if (!groups.has(key)) groups.set(key, { key, transactionId: candidate.transactionId, currencyCode: candidate.currencyCode, available: candidate.transactionRemainingAmount, items: new Map() });
    groups.get(key).items.set(candidate.openItemId, candidate.openItemRemainingAmount);
  }
  return [...groups.values()].filter(group => group.items.size > 1).map(group => ({
    key: group.key, transactionId: group.transactionId, currencyCode: group.currencyCode,
    available: group.available, itemCount: group.items.size,
    total: Math.round([...group.items.values()].reduce((sum, value) => sum + Number(value), 0) * 100) / 100,
  }));
}
module.exports = { summarizePayments };
